import React, { FC } from 'react';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import cn from 'classnames';
import styles from 'components/admin/orders/recurring-orders/individualRecurringOrder.module.scss';
import { TimelineItem as Item, TimelineActions } from 'api/admin/orders/getRecurringOrder';
import { ORIGIN_DISPLAY } from 'constants/recurringOrders/origins';

const ITEM_TYPE_DISPLAY = {
  [TimelineActions.INSTANCE_SKIP]: 'An upcoming order skip is requested',
  [TimelineActions.INSTANCE_UPDATE]: 'An upcoming order settings updated',
  [TimelineActions.PICKUP_CONFLICT_HANDLED]: 'Order pickup conflict dismissed',
  [TimelineActions.RETURN_CONFLICT_HANDLED]: 'Order return conflict dismissed',
};

export const CustomInstanceItem: FC<{
  item: Item;
}> = ({ item }) => {
  return (
    <TimelineItem
      key={`${item.itemTimestamp} ${item.instanceWeek}`}
      className={styles.timeLineItem}
    >
      <TimelineOppositeContent color="textSecondary" className={styles.timestamp}>
        {item.itemTimestamp}
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent className={styles.timelineItemContent}>
        <p
          className={cn(styles.title, {
            [styles.dangerText]: item.action === TimelineActions.INSTANCE_SKIP,
          })}
        >
          {ITEM_TYPE_DISPLAY[item.action]}
        </p>
        <p className={styles.target}>
          Target pickup week: <span>{item.instanceWeek}</span>
        </p>
        {item.teamMemberName && (
          <p className={styles.author}>
            Author: <span>{item.teamMemberName}</span>
          </p>
        )}
        {item.origin && (
          <p className={styles.author}>
            Origin: <span>{ORIGIN_DISPLAY[item.origin]}</span>
          </p>
        )}
      </TimelineContent>
    </TimelineItem>
  );
};
